import { render, staticRenderFns } from "./App.vue?vue&type=template&id=a5b50b46"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=a5b50b46&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../Users/liujianting/manyuTop/ui/comic_ai/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports